import React from 'react';
import PropTypes from 'prop-types';

import {DialogContent, Grid} from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import ResponsiveDialog from '../../../../components/ResponsiveDialog/ResponsiveDialog';
import useStyles from './styles';

function ResponsiveModalShell({open, onClose, footer, children}) {
  const classes = useStyles();

  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      <DialogTitle>
        <div className={classes.header}>
          <IconButton
            disableRipple
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent classes={{root: classes.dialogContentRoot}}>
        {children}
      </DialogContent>

      {footer && (
        <DialogActions classes={{root: classes.dialogActionsRoot}}>
          <Grid container spacing={2} justify={'space-between'}>
            {footer}
          </Grid>
        </DialogActions>
      )}
    </ResponsiveDialog>
  );
}

ResponsiveModalShell.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  footer: PropTypes.node,
  children: PropTypes.node,
};

export default ResponsiveModalShell;
